import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import {
  Stack,
  Container,
  TextField,
  Button,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  MenuItem,
  FormControl,
  CircularProgress
} from "@mui/material";
import Grid from "@mui/material/Grid";
import Select from "react-select";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { enGB } from "date-fns/locale";
import { checkMemberValidation, insertPrimeMember, UpdatePrimeMember, searchMemberList } from "src/api/commonapi";
import { notification } from "src/utils/messages";
import moment from "moment";
import { getInvoiceSetting } from "src/api/updateSetting";
import { gender, occupationType, statusList } from "src/constant/variable";
import { fetchallcitylist, fetchallcountrylist, fetchallstatelist } from "src/utils/common";
// ----------------------------------------------------------------------

export default function MemberForm({ setStep, data, step, memberlist }) {
  let loginUser = JSON.parse(localStorage.getItem("userData"));
  const [invoiceData, setInvocieData] = useState([]);

  const [response, setresponse] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [countrylist, setcountrylist] = useState([]);
  const [statelist, setstatelist] = useState([]);
  const [citylist, setcitylist] = useState([]);
  const [memberOptions, setMemberOptions] = useState([]);
  const [memberSearchLoading, setMemberSearchLoading] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [memberPage, setMemberPage] = useState(1);
  const [memberTotalRecords, setMemberTotalRecords] = useState(0);
  const [memberSearchTerm, setMemberSearchTerm] = useState("");
  const [formdata, setformdata] = useState({
    joining_date: "",
    due_date: "",
    gender: 0,
    m_name: "",
    type: 6,
    m_email_id: "",
    mobile_no: "",
    password: "",
    business_name: "",
    business_category: "",
    pr_reference: "",
    pr_payment_mode: 1,
    pr_amount: 0,
    pr_without_gst_amt: 0,
    pr_transaction_id: "",
    pr_ex1: "",
    pr_ex2: "",
    pr_ex3: "",
    c_id: 0,
    state_id: 0,
    city_id: 0,
    member_source: 0,
    pr_welcome_kit_status: -1
  });

  let startdate = {};
  let new_date = {};
  // const setnewformdata = (e) => {

  //   console.log('e', e)
  //   // e.preventDefault();
  //   const { name, value } = e.target;
  //   if (name == "mobile_no") {
  //     if (e.target.value.length > 10) {
  //     } else {
  //       // setformdata({ ...formdata, [e.target.name]: e.target.value });
  //       setformdata((prev) => ({
  //         ...prev,
  //         [name]: value
  //       }));

  //       if (name == "pr_payment_mode" && value == "0") {
  //         setformdata((prev) => ({
  //           ...prev,
  //           pr_amount: invoiceData.data.gst_plan_price,
  //           pr_without_gst_amt: invoiceData.data.plan_price
  //         }));
  //       }

  //       if (name == "pr_payment_mode" && value == "1") {
  //         setformdata((prev) => ({
  //           ...prev,
  //           pr_amount: 0,
  //           pr_without_gst_amt: 0
  //         }));
  //       }
  //     }
  //   } else {
  //     // setformdata({ ...formdata, [e.target.name]: e.target.value });
  //     setformdata((prev) => ({
  //       ...prev,
  //       [name]: value
  //     }));

  //     if (name == "pr_payment_mode" && value == "0") {
  //       setformdata((prev) => ({
  //         ...prev,
  //         pr_amount: invoiceData.data.gst_plan_price,
  //         pr_without_gst_amt: invoiceData.data.plan_price
  //       }));
  //     }

  //     if (name == "pr_payment_mode" && value == "1") {
  //       setformdata((prev) => ({
  //         ...prev,
  //         pr_amount: 0,
  //         pr_without_gst_amt: 0
  //       }));
  //     }
  //   }
  // };

  const setnewformdata = (e, name) => {
    // Case 1: react-select (gives selected object + custom name)
    if (name && name !== "pr_payment_mode") {
      setformdata((prev) => ({
        ...prev,
        [name]: e?.value || "" // e is { label, value }
      }));
      return;
    }

    // Case 2: normal inputs (MUI TextField, RadioGroup, etc.)
    const { name: fieldName, value } = e.target;

    // Special case: mobile_no max length 10
    if (fieldName === "mobile_no" && value.length > 10) return;

    setformdata((prev) => ({
      ...prev,
      [fieldName]: value
    }));

    // Payment mode special logic
    if (fieldName === "pr_payment_mode") {
      if (value == "0") {
        setformdata((prev) => ({
          ...prev,
          pr_amount: invoiceData.data.gst_plan_price,
          pr_without_gst_amt: invoiceData.data.plan_price
        }));
      }
      if (value == "1") {
        setformdata((prev) => ({
          ...prev,
          pr_amount: 0,
          pr_without_gst_amt: 0
        }));
      }
    }
  };

  useEffect(async () => {
    if (step == 3) {
      setformdata(data);
      if (data?.l_ref_m_id && data?.referral_m_name) {
        setSelectedMember({ label: data.referral_m_name, value: data.l_ref_m_id });
      }
    }
    setInvocieData(await getInvoiceSetting());
  }, []);

  const getallcountrylist = async () => {
    setcountrylist(await fetchallcountrylist());
  };

  const getallstatelist = async () => {
    setstatelist(await fetchallstatelist());
  };

  const getallcitylist = async () => {
    setcitylist(await fetchallcitylist());
  };

  useEffect(async () => {
    getallstatelist();
    getallcitylist();
    getallcountrylist();
    fetchMemberOptions("");
  }, []);

  const fetchMemberOptions = async (search, page = 1) => {
    setMemberSearchLoading(true);
    try {
      const resp = await searchMemberList({ page, per_page: 50, search });
      if (resp.status == 1 && resp.data) {
        setMemberOptions((prev) =>
          page === 1 ? resp.data : prev.length === 0 ? [...resp.data] : [...prev, ...resp.data]
        );
        setMemberTotalRecords(resp.total_records || 0);
        setMemberPage(page);
        setMemberSearchTerm(search);
      } else {
        if (page === 1) setMemberOptions([]);
        setMemberTotalRecords(0);
      }
    } catch {
      if (page === 1) setMemberOptions([]);
      setMemberTotalRecords(0);
    }
    setMemberSearchLoading(false);
  };

  const loadMoreMembers = () => {
    const nextPage = memberPage + 1;
    if (memberOptions.length < memberTotalRecords && !memberSearchLoading) {
      fetchMemberOptions(memberSearchTerm, nextPage);
    }
  };

  const handleMemberSearch = (inputValue, actionMeta) => {
    if (actionMeta.action !== "input-change") return;
    if (window.__memberSearchTimer) clearTimeout(window.__memberSearchTimer);
    window.__memberSearchTimer = setTimeout(() => {
      fetchMemberOptions(inputValue, 1);
    }, 300);
  };

  const handleSubmit = async () => {
    let resp = null;
    if (step == 2) {
      if (
        // formdata.gender != 0 &&
        formdata.m_name != "" &&
        formdata.mobile_no != "" &&
        formdata.password != "" &&
        formdata.joining_date != "" &&
        formdata.m_email_id != ""
      ) {
        let fdata = new FormData();
        fdata.append("gender", formdata.gender);
        fdata.append("m_name", formdata.m_name);
        fdata.append("mobile_no", formdata.mobile_no);
        fdata.append("m_email_id", formdata.m_email_id);
        fdata.append("password", formdata.password);
        fdata.append("type", 6);
        fdata.append("business_name", formdata.business_name);
        fdata.append("business_category", formdata.business_category);
        fdata.append("pr_reference", formdata.pr_reference);
        fdata.append("joining_date", formdata.joining_date);
        fdata.append("status", 1);
        fdata.append("is_login", 0);
        fdata.append("pr_reg_date", moment().format("DD-MM-YYYY hh:mma"));
        fdata.append("pr_p_status", 2);
        fdata.append("pr_payment_mode", formdata.pr_payment_mode);
        fdata.append("pr_amount", formdata.pr_amount);
        fdata.append("pr_without_gst_amt", formdata.pr_without_gst_amt);
        fdata.append("pr_transaction_id", formdata.pr_transaction_id);
        fdata.append("pr_ex1", formdata.pr_ex1);
        fdata.append("pr_ex2", formdata.pr_ex2);
        fdata.append("member_source", 0);
        fdata.append("from_type", 1);
        fdata.append("pr_welcome_kit_status", formdata.pr_payment_mode == 1 ? 3 : 0);
        fdata.append("pr_occupation_type", formdata.occupation_type);
        fdata.append("dob", formdata.dob);
        fdata.append("country_id", formdata.c_id);
        fdata.append("state_id", formdata.state_id);
        fdata.append("city_id", formdata.city_id);
        fdata.append("pr_m_address", formdata.pr_m_address ? formdata.pr_m_address : "");
        fdata.append(
          "pr_welcome_kit_address",
          formdata.pr_welcome_kit_address ? formdata.pr_welcome_kit_address : ""
        );
        fdata.append("village", formdata.village ? formdata.village : "");
        fdata.append("b_address", formdata.pr_m_address ? formdata.pr_m_address : "");
        fdata.append("l_ref_m_id", formdata.l_ref_m_id || "");
        setLoading(true);
        setIsLoading(true);
        resp = await insertPrimeMember(fdata);
        setIsLoading(false);
        let notify = notification({
          type: resp.status == 0 ? "error" : "success",
          message: resp.message
        });
        notify();
        setLoading(false);
      } else {
        let notify = notification({
          type: "error",
          message: "Enter All Details And Try Again"
        });
        notify();
      }
    } else {
      if (
        // formdata.gender != 0 &&
        formdata.m_name != "" &&
        formdata.mobile_no != "" &&
        formdata.password != "" &&
        formdata.joining_date != "" &&
        formdata.m_email_id != ""
      ) {
        setLoading(true);

        let checkMobile = await checkMemberValidation({
          m_id: data.m_id,
          mobile_no: formdata.mobile_no
        });

        if (checkMobile?.status != 0) {
          let fdata = new FormData();
          fdata.append("m_id", data.m_id);
          fdata.append("gender", formdata.gender);
          fdata.append("m_name", formdata.m_name);
          fdata.append("mobile_no", formdata.mobile_no);
          fdata.append("m_email_id", formdata.m_email_id);
          fdata.append("password", formdata.password);
          fdata.append("type", 6);
          fdata.append("business_name", formdata.business_name);
          fdata.append("business_category", formdata.business_category);
          fdata.append("pr_reference", formdata.pr_reference);
          fdata.append("joining_date", formdata.joining_date);
          fdata.append("pr_payment_mode", formdata.pr_payment_mode);
          fdata.append("pr_amount", formdata.pr_amount);
          fdata.append("member_source", 0);
          fdata.append("pr_without_gst_amt", formdata.pr_without_gst_amt);
          fdata.append("pr_transaction_id", formdata.pr_transaction_id);
          fdata.append("pr_ex1", formdata.pr_ex1);
          fdata.append("pr_ex2", formdata.pr_ex2);
          fdata.append("pr_welcome_kit_status", formdata.pr_payment_mode == 1 ? 3 : 0);
          fdata.append("pr_occupation_type", formdata.occupation_type);
          fdata.append("dob", formdata.dob);
          fdata.append("country_id", formdata.c_id);
          fdata.append("state_id", formdata.state_id);
          fdata.append("city_id", formdata.city_id);
          fdata.append("pr_m_address", formdata.pr_m_address ? formdata.pr_m_address : "");
          fdata.append(
            "pr_welcome_kit_address",
            formdata.pr_welcome_kit_address ? formdata.pr_welcome_kit_address : ""
          );
          fdata.append("village", formdata.village ? formdata.village : "");
          fdata.append("b_address", formdata.pr_m_address ? formdata.pr_m_address : "");
          fdata.append("l_ref_m_id", formdata.l_ref_m_id || "");
          setIsLoading(true);
          resp = await UpdatePrimeMember(fdata);
          setIsLoading(false);
          setLoading(false);
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
          setresponse(response + 1);
        } else {
          let notify = notification({
            type: checkMobile.status == 0 ? "error" : "success",
            message: checkMobile.message
          });
          notify();
        }
      } else {
        let notify = notification({
          type: "error",
          message: "Enter All Details And Try Agani"
        });
        notify();
      }
    }
    if (resp?.status == 1) setStep(1);
  };

  return (
    <Container>
      <Stack spacing={10} style={{ marginBottom: "15px" }}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Stack spacing={3} style={{ marginBottom: "15px", marginTop: "5px" }}>
              {/* <label style={{ marginBottom: '10px' }}>Join Date</label> */}
              <LocalizationProvider
                dateAdapter={AdapterDateFns}
                adapterLocale={enGB}
                isDisabled
                style={{ marginTop: "15px" }}
              >
                <DatePicker
                  disabled={
                    loginUser?.u_type == 3 ||
                      (loginUser?.u_type == 2 &&
                        loginUser?.p_user_id == 1 &&
                        loginUser?.management_p != 0)
                      ? false
                      : true
                  }
                  disableFuture
                  type="date"
                  name="joindate"
                  label="Joining Date *"
                  value={
                    formdata.joining_date
                      ? new Date(formdata.joining_date.split("-").reverse().join("-")) // Converts "DD-MM-YYYY" to "YYYY-MM-DD"
                      : null
                  }
                  inputFormat="dd/MM/yyyy"
                  onChange={(newDate) => {
                    if (newDate instanceof Date && !isNaN(newDate)) {
                      const day = String(newDate.getDate()).padStart(2, "0");
                      const month = String(newDate.getMonth() + 1).padStart(2, "0");
                      const year = newDate.getFullYear();
                      setformdata({
                        ...formdata,
                        joining_date: `${day}-${month}-${year}`
                      });
                    }
                  }}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack spacing={3} style={{ marginBottom: "15px" }}>
              <FormControl component="fieldset">
                <FormLabel component="legend">Gender</FormLabel>

                <RadioGroup
                  name="gender"
                  row // remove this if you want vertical
                  value={formdata?.gender || 0}
                  onChange={(e) => {
                    setnewformdata(e.target, "gender");
                  }}
                >
                  {gender
                    .filter((g) => g.value !== 0) // remove "Select Gender"
                    .map((g) => (
                      <FormControlLabel
                        key={g.value}
                        value={g.value}
                        control={<Radio />}
                        label={g.label}
                      />
                    ))}
                </RadioGroup>
              </FormControl>
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack spacing={3} style={{ marginBottom: "15px" }}>
              <TextField
                style={{ marginTop: "0px" }}
                fullWidth
                autoComplete="off"
                type="text"
                label="Member Name *"
                name="m_name"
                value={formdata?.m_name}
                onChange={setnewformdata}
              />
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack spacing={3} style={{ marginBottom: "15px" }}>
              <TextField
                style={{ marginTop: "0px" }}
                fullWidth
                autoComplete="off"
                type="email"
                label="Member Email Id *"
                name="m_email_id"
                value={formdata?.m_email_id}
                onChange={setnewformdata}
              />
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack spacing={3} style={{ marginBottom: "15px" }}>
              <TextField
                inputProps={{ inputMode: "numeric", pattern: "[0-9]*", maxLength: 10 }}
                style={{ marginTop: "0px" }}
                fullWidth
                autoComplete="off"
                type="number"
                label="Member Contact No *"
                onWheel={(e) => e.currentTarget.blur()}
                name="mobile_no"
                value={formdata?.mobile_no}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");

                  setnewformdata({
                    target: {
                      name: e.target.name,
                      value: value
                    }
                  });
                }}
              />
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack spacing={3} style={{ marginBottom: "15px" }}>
              <TextField
                style={{ marginTop: "0px" }}
                fullWidth
                autoComplete="off"
                type="text"
                label="Member Password *"
                name="password"
                value={formdata?.password}
                onChange={setnewformdata}
              />
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack spacing={3} style={{ marginBottom: "15px" }}>
              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
                <DatePicker
                  disableFuture
                  type="dob"
                  label="Date Of Birth"
                  inputFormat="dd/MM/yyyy"
                  value={
                    formdata.dob
                      ? new Date(formdata.dob.split("-").reverse().join("-")) // Converts "DD-MM-YYYY" to "YYYY-MM-DD"
                      : null
                  }
                  onChange={(newDate) => {
                    if (newDate instanceof Date && !isNaN(newDate)) {
                      const day = String(newDate.getDate()).padStart(2, "0");
                      const month = String(newDate.getMonth() + 1).padStart(2, "0");
                      const year = newDate.getFullYear();
                      setformdata({
                        ...formdata,
                        dob: `${day}-${month}-${year}`
                      });
                    }
                  }}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />
              </LocalizationProvider>
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack spacing={3} style={{ marginBottom: "15px" }}>
              <TextField
                style={{ marginTop: "0px" }}
                fullWidth
                autoComplete="off"
                type="text"
                label="Business Name"
                name="business_name"
                value={formdata?.business_name}
                onChange={setnewformdata}
              />
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack spacing={3} style={{ marginBottom: "15px" }}>
              <TextField
                style={{ marginTop: "0px" }}
                fullWidth
                autoComplete="off"
                type="text"
                label="Business Category"
                name="business_category"
                value={formdata?.business_category}
                onChange={setnewformdata}
              />
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack spacing={3} style={{ marginBottom: "15px" }}>
              <label>Select Country</label>
              <Select
                options={countrylist.map((country) => ({
                  label: country?.country_name,
                  value: country?.c_id
                }))}
                value={countrylist.map((country) => {
                  return (
                    formdata.c_id == country.c_id && {
                      value: country.c_id,
                      label: country.country_name
                    }
                  );
                })}
                onChange={(selected) => setnewformdata(selected, "c_id")}
              />
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack spacing={3} style={{ marginBottom: "15px" }}>
              <label>Select State</label>
              <Select
                options={statelist
                  ?.filter((items) => items.c_id === formdata.c_id)
                  ?.map((state) => ({
                    label: state?.state_name,
                    value: state?.state_id
                  }))}
                value={statelist.map((state) => {
                  return (
                    formdata.state_id == state.state_id && {
                      value: state.state_id,
                      label: state.state_name
                    }
                  );
                })}
                onChange={(selected) => setnewformdata(selected, "state_id")}
              />
            </Stack>
          </Grid>

          <Grid item xs={6}>
            <Stack spacing={3} style={{ marginBottom: "15px" }}>
              <label>Select City</label>
              <Select
                options={citylist
                  ?.filter((items) => items.state_id === formdata.state_id)
                  .map((city) => {
                    return {
                      label: city?.city_name,
                      value: city?.city_id
                    };
                  })}
                value={citylist.map((city) => {
                  return (
                    formdata.city_id == city.city_id && {
                      value: city.city_id,
                      label: city.city_name
                    }
                  );
                })}
                onChange={(selected) => setnewformdata(selected, "city_id")}
              />
            </Stack>
          </Grid>
          {/* <Grid item xs={6}>
            <Stack spacing={3} style={{ marginBottom: "15px" }}>
              <label>All Welcome Kit Status</label>
              <Select
                value={
                  formdata.pr_welcome_kit_status === -1
                    ? { value: -1, label: "All Welcome Kit Status" }
                    : statusList?.map((st) => {
                        if (st.value == formdata.pr_welcome_kit_status) {
                          return { value: st.value, label: st.label };
                        }
                      })
                }
                menuPortalTarget={document.body}
                onChange={(selected) => setnewformdata(selected, "pr_welcome_kit_status")}
                options={[{ value: -1, label: "All Welcome Kit Status" }, ...statusList]}
              />
            </Stack>
          </Grid> */}
          <Grid item xs={6}>
            <Stack spacing={3} style={{ marginBottom: "15px" }}>
              <label>Occupation Type</label>
              <Select
                value={occupationType?.map((st) => {
                  if (st.value == formdata.occupation_type) {
                    return { value: st.value, label: st.label };
                  }
                })}
                menuPortalTarget={document.body}
                onChange={(selected) => setnewformdata(selected, "occupation_type")}
                options={occupationType}
              />
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack spacing={3} style={{ marginBottom: "15px" }}>
              <label>{step === 3 && data?.m_referral_code ? "Referral By" : "Reference By"}</label>
              <Select
                isClearable
                isDisabled={step === 3 && !!data?.m_referral_code}
                isLoading={memberSearchLoading}
                options={memberOptions.map((m) => ({
                  label: m.m_name,
                  value: m.m_id
                }))}
                value={selectedMember}
                onChange={(selected) => {
                  setSelectedMember(selected);
                  setnewformdata(selected, "l_ref_m_id");
                }}
                onInputChange={handleMemberSearch}
                onMenuScrollToBottom={loadMoreMembers}
                onMenuOpen={() => {
                  if (memberOptions.length === 0) fetchMemberOptions("");
                }}
                placeholder="Search member..."
                menuPortalTarget={document.body}
              />
            </Stack>
          </Grid>

          <Grid item xs={6}>
            {/* <Grid item xs={6}> */}
            <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginBottom: "0px" }}>
              Payment Mode
            </FormLabel>
            <RadioGroup
              style={{ marginTop: "0px", display: "flex", flexFlow: "row" }}
              row
              disabled={step === 3}
              value={formdata.pr_payment_mode}
              onChange={(e) => setnewformdata(e, "pr_payment_mode")}
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="pr_payment_mode"
            >
              <FormControlLabel
                value="1"
                control={<Radio disabled={step === 3} />}
                label="Offline"
              />
              <FormControlLabel
                value="0"
                control={<Radio disabled={step === 3} />}
                label="Online"
              />
            </RadioGroup>
            {/* </Grid> */}
          </Grid>
          <Grid item xs={6}>
            <Stack spacing={3} style={{ marginBottom: "15px" }}>
              <TextField
                style={{ marginTop: "0px" }}
                fullWidth
                autoComplete="off"
                type="text"
                label="Without GST Amount"
                name="pr_without_gst_amt"
                value={formdata?.pr_without_gst_amt || 0}
                onChange={setnewformdata}
              />
            </Stack>
          </Grid>
          {step === 3 ? (
            <Grid item xs={6}>
              <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginBottom: "0px" }}>
                Membership Type
              </FormLabel>
              <h3>{formdata.member_source === 0 ? "Prime" : "Privilege"}</h3>
              {/* <RadioGroup
                style={{ marginTop: "0px", display: "flex", flexFlow: "row" }}
                row
                disabled={step === 3}
                value={formdata.member_source}
                onChange={setnewformdata}
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="member_source"
              >
                <FormControlLabel value="1" control={<Radio />} label="Prime Membership" />
              </RadioGroup> */}
            </Grid>
          ) : (
            ""
          )}
          <Grid item xs={6}>
            <Stack spacing={3} style={{ marginBottom: "15px" }}>
              <TextField
                style={{ marginTop: "0px" }}
                fullWidth
                autoComplete="off"
                type="text"
                label="Amount"
                name="pr_amount"
                value={formdata?.pr_amount || 0}
                onChange={setnewformdata}
              />
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack spacing={3} style={{ marginBottom: "15px" }}>
              <TextField
                style={{ marginTop: "0px" }}
                fullWidth
                autoComplete="off"
                type="text"
                label="Transaction Id"
                name="pr_transaction_id"
                value={formdata?.pr_transaction_id}
                onChange={setnewformdata}
              />
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack spacing={3} style={{ marginBottom: "15px" }}>
              <TextField
                style={{ marginTop: "0px" }}
                fullWidth
                autoComplete="off"
                type="text"
                label="Whatsapp Group"
                name="pr_ex1"
                value={formdata?.pr_ex1}
                onChange={setnewformdata}
              />
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack spacing={3} style={{ marginBottom: "15px" }}>
              <TextField
                style={{ marginTop: "0px" }}
                fullWidth
                autoComplete="off"
                type="text"
                label="Village"
                name="village"
                value={formdata?.village}
                onChange={setnewformdata}
              />
            </Stack>
          </Grid>

          <Grid item xs={12}>
            <Stack spacing={3} style={{ marginBottom: "15px" }}>
              <TextField
                multiline
                rows={2}
                style={{ marginTop: "0px" }}
                fullWidth
                autoComplete="off"
                type="text"
                label="Address"
                name="pr_m_address"
                value={
                  formdata?.pr_m_address != null ? formdata?.pr_m_address : formdata?.b_address
                }
                onChange={setnewformdata}
              />
            </Stack>
          </Grid>
          <Grid item xs={12}>
            <Stack spacing={3} style={{ marginBottom: "15px" }}>
              <TextField
                multiline
                rows={2}
                style={{ marginTop: "0px" }}
                fullWidth
                autoComplete="off"
                type="text"
                label="Welcome Kit Address"
                name="pr_welcome_kit_address"
                value={
                  formdata?.pr_welcome_kit_address != null ? formdata?.pr_welcome_kit_address : ""
                }
                onChange={setnewformdata}
              />
            </Stack>
          </Grid>
          <Grid item xs={4}>
            <Stack spacing={3} style={{ marginBottom: "15px" }}>
              <TextField
                style={{ marginTop: "0px" }}
                fullWidth
                autoComplete="off"
                type="text"
                label="Extra Field 2"
                name="pr_ex2"
                value={formdata?.pr_ex2}
                onChange={setnewformdata}
              />
            </Stack>
          </Grid>
          <Grid item xs={4}>
            <Stack spacing={1} style={{ marginBottom: "15px" }}>
              <strong>Privacy Policy Accept:</strong>
              {data?.m_privacy_policy_status === 1 ? (
                <span>
                  Yes {data?.m_privacy_policy_date && <em>({data.m_privacy_policy_date})</em>}
                </span>
              ) : (
                "No"
              )}
            </Stack>
          </Grid>
          <Grid item xs={4}>
            <Stack spacing={1} style={{ marginBottom: "15px" }}>
              <strong>Terms & Conditions Accept:</strong>
              {data?.m_term_condition_status === 1 ? (
                <span>
                  Yes {data?.m_term_condition_date && <em>({data.m_term_condition_date})</em>}
                </span>
              ) : (
                "No"
              )}
            </Stack>
          </Grid>
        </Grid>
      </Stack>
      <Button
        style={{ marginTop: "15px" }}
        onClick={handleSubmit}
        variant="contained"
        // disabled={loading}
        disabled={isLoading}
        startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
      >
        Save
      </Button>
    </Container>
  );
}
